import React, { useState } from "react"
import { render } from 'react-dom'
import { BrowserRouter, Route, Routes, Outlet, Navigate, useLocation } from 'react-router-dom'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import Forecast from './components/Forecast'
import Statistics from './components/Statistics'
import Channels from './components/Channels'
import Logs from './components/Logs'
import Profile from './components/Profile'
import PrivateRoute from './components/PrivateRoute'
import Page from './components/Page'
import Header from './components/Header'
import { ProvideAuth, useAuth } from './hooks/Auth'
import { ProvideDialog } from './hooks/Dialog'
import { Dialog } from './components/Dialog'
import { Events } from './hooks/Events'
import './index.css'

function App() {
  document.body.className= "bg-default"
  const auth = useAuth()
  const location = useLocation()
  const [facility, setFacility] = useState(null)
  if (!auth.token && !auth.user && location.pathname !== "/login") {
    return <Navigate to="/login"/>
  }
  return (
    <Routes>
      <Route element={
        <>
          <Header user={auth.user} signout={auth.signout}/>
          <Outlet/>
        </>
      }>
        <Route element={<Page facility={facility} setFacility={setFacility}/>}>
          <Route
            index
            element={
              <PrivateRoute user={auth.user}>
                <Dashboard user={auth.user} facility={facility}/>
              </PrivateRoute>
            }
          />
          <Route
            path="/statistics"
            element={
              <PrivateRoute user={auth.user} feature="stats">
                <Statistics facility={facility}/>
              </PrivateRoute>
            }
          />
          <Route
            path="/forecast"
            element={
              <PrivateRoute user={auth.user} feature="predict">
                <Forecast facility={facility}/>
              </PrivateRoute>
            }
          />
          <Route
            path="/sensors"
            element={
              <PrivateRoute user={auth.user} superuser={true}>
                <Channels facility={facility}/>
              </PrivateRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <PrivateRoute user={auth.user} superuser={true}>
                <Logs facility={facility}/>
              </PrivateRoute>
            }
          />
        </Route>
        <Route
          path="/profile"
          element={
            <PrivateRoute user={auth.user}>
              <Profile user={auth.user}/>
            </PrivateRoute>
          }
        />
      </Route>
      <Route
        path="/login"
        element={
          <Login scopes={[
            'facility:read',
            'facility:write',
            'report:read',
            'report:write',
            'predict',
            'stats',
            'remote'
          ]}/>
        }
      />
    </Routes>
  )
}

const rootElement = document.getElementById("root")
render(
  <ProvideDialog>
    <ProvideAuth>
      <Events>
        <BrowserRouter>
          <App/>
          <Dialog/>
        </BrowserRouter>
      </Events>
    </ProvideAuth>
  </ProvideDialog>
, rootElement)
